// src/components/perfil/components/UserInfo.js

import React from 'react';

function UserInfo({ user }) {
  return (
    <div className="white-box">
      <div className="user-btm-box p-2">
        {/* CPF/CNPJ */}
        <div className="row text-center m-0">
          <div className="col-12">
            <strong>CPF/CNPJ</strong>
            <p>{user.cpf_cnpj}</p>
          </div>
        </div>

        {/* Nome e Departamento */}
        <div className="row text-center m-0">
          <div className="col-md-6 b-r">
            <strong>Nome</strong>
            <p>{user.nome}</p>
          </div>
          <div className="col-md-6">
            <strong>Departamento</strong>
            <p>{user.nome_fantasia}</p>
          </div>
        </div>

        <hr />

        {/* Email */}
        <div className="row text-center m-t-10">
          <div className="col-md-12 b-r">
            <strong>Email</strong>
            <p>{user.email}</p>
          </div>
        </div>

        {/* Telefones */}
        <div className="row text-center m-t-10">
          <div className="col-md-12 b-r">
            <strong>Telefone(s)</strong>
            <p>{user.telefone1}</p>
            {user.telefone2 && <p>{user.telefone2}</p>}
          </div>
        </div>

        <hr />

        {/* Endereço */}
        <div className="row text-center m-t-10">
          <div className="col-md-12">
            <strong>Endereço</strong>
            <p>
              {user.endereço}, {user.numero} - {user.cep}
              <br />
              {user.cidade} - {user.uf}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserInfo;
